<template>
    <div>
        <el-radio-group v-model="humanSide" fill="#833e93" text-color="#ffffff" size="small">
            <el-radio-button label="Front"></el-radio-button>
            <el-radio-button label="Back"></el-radio-button>
        </el-radio-group>

        <div class="human-map-wrapper">
            <span :class="humanSideLowerCase + '_left'">LEFT</span>
            <span :class="humanSideLowerCase + '_right'">RIGHT</span>
            <div key="body">
                <body_f
                    v-if="humanSide === 'Front' && !isFrontAllPartsSelected"
                    :key="selectedParts.length"
                    color="#B2B2B2"
                    class="body_f">
                </body_f>
                <body_f_selected
                    v-if="humanSide === 'Front' && isFrontAllPartsSelected"
                    :key="selectedParts.length"
                    class="body_f">
                </body_f_selected>
                <body_b
                    v-if="humanSide === 'Back' && !isBackAllPartsSelected"
                    :key="selectedParts.length"
                    color="#B2B2B2"
                    class="body_b">
                </body_b>
                <body_b_selected
                    v-if="humanSide === 'Back' && isBackAllPartsSelected"
                    :key="selectedParts.length"
                    class="body_b">
                </body_b_selected>
            </div>
            <div v-for="bodyPart in humanMap" :key="bodyPart.id">
                <template v-if="bodyPart.side.toLowerCase() === humanSideLowerCase">
                    <div class="tooltip" v-if="selectedParts.filter(bp => bp.id === bodyPart.id).length">
                        <span :ref="bodyPart.id + '_tooltip'" class="tooltiptext">{{ bodyPart.tooltip }}</span>
                    </div>
                    <div 
                        :is="bodyPart.id === 'head' ? 'head_map' : bodyPart.id" 
                        :ref="bodyPart.id"
                        :key="selectedParts.length" 
                        :class="bodyPart.id"  
                        @click.native="toggle(bodyPart.id)" 
                        :color="selectedParts.filter(bp => bp.id === bodyPart.id).length ? '#833E93' : '#CCCCCC'">
                    </div>
                </template>
            </div>
        </div>
        <div class="selected-text">
            <span v-if="calcSelectedList['Front'].length" style="margin-top: 20px; ">Front<br>
                <span v-for="part in calcSelectedList['Front']" :key="part" class="bullet-text">&bull; {{ part }}</span>
            </span>
            <br><br>
            <span v-if="calcSelectedList['Back'].length" style="margin-top: 10px;">Back<br>
                <span v-for="part in calcSelectedList['Back']" :key="part" class="bullet-text">&bull; {{ part }}</span>
            </span>
        </div>

    </div>
</template>

<script>
    import Vue from 'vue'
    import { RadioGroup, RadioButton } from 'element-ui'
    import { v4 as uuidv4 } from 'uuid'
    import SubQuestion from './index'
    import IconComponents from '../icon/Rash/components'

    Vue.use(RadioGroup)
    Vue.use(RadioButton)

    const humanMap = [
        { id: 'head', side: 'Front', tooltip: 'Head' },
        { id: 'groin', side: 'Front', tooltip: 'Groin' },
        { id: 'chest', side: 'Front', tooltip: 'Chest' },
        { id: 'right_foot', side: 'Front', tooltip: 'Right Foot' },
        { id: 'left_foot', side: 'Front', tooltip: 'Left Foot' },
        { id: 'right_leg_f', side: 'Front', tooltip: 'Right Leg (F)' },
        { id: 'left_leg_f', side: 'Front', tooltip: 'Left Leg (F)' },
        { id: 'right_arm_f', side: 'Front', tooltip: 'Right Arm (F)' },
        { id: 'left_arm_f', side: 'Front', tooltip: 'Left Arm (F)' },
        { id: 'stomach', side: 'Front', tooltip: 'Stomach' },
        { id: 'right_hand_f', side: 'Front', tooltip: 'Right Hand (F)' },
        { id: 'left_hand_f', side: 'Front', tooltip: 'Left Hand (F)' },
        { id: 'neck_f', side: 'Front', tooltip: 'Neck (F)' },
        { id: 'right_under_arm', side: 'Front', tooltip: 'Right Under Arm' },
        { id: 'left_under_arm', side: 'Front', tooltip: 'Left Under Arm' },


        { id: 'right_leg_b', side: 'Back', tooltip: 'Right Leg (B)' },
        { id: 'left_leg_b', side: 'Back', tooltip: 'Left Leg (B)' },
        { id: 'back', side: 'Back', tooltip: 'Back' },
        { id: 'neck_b', side: 'Back', tooltip: 'Neck (B)' },
        { id: 'glutes_buttock', side: 'Back', tooltip: 'Glutes (Buttock)' },
        { id: 'right_arm_b', side: 'Back', tooltip: 'Right Arm (B)' },
        { id: 'left_arm_b', side: 'Back', tooltip: 'Left Arm (B)' },
        { id: 'right_hand_b', side: 'Back', tooltip: 'Right Hand (B)' },
        { id: 'left_hand_b', side: 'Back', tooltip: 'Left Hand (B)' }
    ]

    export default {
        name: 'rash',
        extends: SubQuestion,
        watch: {
            humanSide: function() {
                this.$nextTick(() => this.removeTooltips())
                this.$emit('changeHumanMapSide', this.humanSide)
            }
        },

        props: {
            saved: {
                type: Array
            }
        },

        data() {
            return {
                humanMap: JSON.parse(JSON.stringify(humanMap)),
                humanSide: 'Front',
                selectedParts: [] || this.saved,
                unsortedBodyParts: [] || this.saved,
                frontTotalParts: JSON.parse(JSON.stringify(humanMap)).filter(ele => ele.side === "Front"),
                backTotalParts: JSON.parse(JSON.stringify(humanMap)).filter(ele => ele.side === "Back"),
                normalizeHumanMap: JSON.parse(JSON.stringify(humanMap)).reduce((acc,ele) => {
                    return { ...acc, [ele.id]: { ...ele }}
                }, {})
            }
        },

        mounted() {
            this.loadData()
            this.$emit('changeHumanMapSide', this.humanSide)
        },

        methods: {
            /**
             * @func placeTooltip
             * @desc places tooltip on body part selection
             * @param bodyPart(String) string indicating if the body part is active or inactive
             */
            placeTooltip(bodyPart) {
                let imgRef = this.$refs[bodyPart][0].$el
                let tooltipRef = this.$refs[bodyPart + '_tooltip'][0]
                tooltipRef.style.visibility = 'visible'

                let top = parseInt(window.getComputedStyle(imgRef, null).getPropertyValue('top').replace('px', ''))
                let left = parseInt(window.getComputedStyle(imgRef, null).getPropertyValue('left').replace('px', ''))

                tooltipRef.style.top = (top + 80) + 'px'
                // for body parts on right side of the screen
                if ((this.humanSide === 'Front' && bodyPart.includes('left')) || (this.humanSide === 'Back' && bodyPart.includes('right'))) {
                    tooltipRef.style.left = (left - 60) + 'px'
                }
                // for body parts on left side of the screen
                else if ((this.humanSide === 'Front' && bodyPart.includes('right')) || (this.humanSide === 'Back' && bodyPart.includes('left'))) {
                    tooltipRef.style.left = (left - 30) + 'px'
                }
                // for head
                else if(bodyPart.includes('head') || bodyPart.includes('neck') || bodyPart.includes('throat') || bodyPart.includes('knee') || bodyPart.includes('abdomen')) {
                    tooltipRef.style.top = (top + 50) + 'px'
                    tooltipRef.style.left = (left) + 'px'
                }
                // for middle body parts
                else tooltipRef.style.left = (left + 10) + 'px'
            },
            /**
             * @func removeTooltips
             * @desc removes all tooltips
             * @param tooltipText(String)
             */
            removeTooltips(tooltipText) {
                if (document.getElementsByClassName('tooltiptext')) {
                    let classes = document.getElementsByClassName('tooltiptext')
                    Object.keys(classes).forEach(cls => {
                        if (!tooltipText || (tooltipText && classes[cls].innerHTML.trim() === tooltipText))
                            classes[cls].style.visibility = 'hidden'
                    })
                }
            },
            loadData() {
                if (!this.saved) this.$emit('selectbp', [])
                else {
                    this.unsortedBodyParts = this.saved
                    this.selectedParts = this.saved
                    this.sortBodyParts()
                    this.$emit('selectbp', this.saved)
                }
                this.$nextTick(() => this.removeTooltips())
            },
            /**
             * @func toggle
             * @desc toggles the state of body part
             * @param bodyPart(String) string indicating if the body part is active or inactive
             */
            toggle(bodyPart) {
                // making inactive
                if (this.selectedParts.filter(bp => bp.id === bodyPart).length) {
                    this.selectedParts = this.selectedParts.filter(part => part.id !== bodyPart)
                    this.unsortedBodyParts = this.unsortedBodyParts.filter(part => part.id !== bodyPart)
                }
                // making active
                else {
                    if (this.limitReached(this.humanSide)) 
                        return

                    let tooltipText = ''
                    let reqObj = {
                        id: bodyPart,
                        value: bodyPart
                    }

                    this.selectedParts.push(reqObj)
                    this.unsortedBodyParts.push(reqObj)

                    tooltipText = this.humanMap.filter(bp => bp.id === bodyPart)[0].tooltip
                    // placing tooltip on top of the body part
                    this.$nextTick(() => this.placeTooltip(bodyPart))
                    // remove tooltip after 1.5seconds
                    setTimeout(() => this.removeTooltips(tooltipText), 1500)
                }
                // sort
                this.sortBodyParts()
                this.$emit('selectbp', this.selectedParts)
            },
            sortBodyParts() {
                let tempSelectedParts = []
                this.humanMap.forEach(bp => {
                    this.selectedParts.forEach(sp => {
                        if (sp.value === bp.id) tempSelectedParts.push(sp)
                    })
                })
                this.selectedParts = tempSelectedParts
            },
            getImage(bodyPart) {
                return require('../icon/Rash/' + bodyPart + '.svg')
            },
        },

        computed: {
            humanSideLowerCase() {
                return this.humanSide.toLowerCase()
            },
            calcSelectedList() {
                let selectedList = { 'Front': [], 'Back': [] }
                this.unsortedBodyParts.forEach(part => {
                    let partObj = this.humanMap.filter(bodyPart => part.value === bodyPart.id)[0]
                    selectedList[partObj.side].push(partObj.tooltip)
                })
                return selectedList
            },
            isFrontAllPartsSelected() {
                return this.selectedParts.filter(ele => this.normalizeHumanMap[ele.id].side === "Front").length === this.frontTotalParts.length
            },
            isBackAllPartsSelected() {
                return this.selectedParts.filter(ele => this.normalizeHumanMap[ele.id].side === "Back").length === this.backTotalParts.length
            }
        },

        components: {
            ...IconComponents
        },
    }
</script>

<style lang="scss" scoped>
    $choice-size: 150px;
    $choice-font-size: 20px;
    @import "style.scss";

    .body_f {
        position: absolute;
        top: 64px;
        right: 21px;
    }

    .body_f_selected {
        position: absolute;
        top: 64px;
        right: 21px;
    }

    .body_b {
        position: absolute;
        top: 64px;
        right: 21px;
    }

    .body_b_selected {
        position: absolute;
        top: 64px;
        right: 21px;
    }


    .head {
        position: absolute;
        top: 70px;
        right: 142px;
    }
    .groin {
        position: absolute;
        top: 344px;
        right: 130px;
    }
    .chest {
        position: absolute;
        top: 190px;
        right: 117px;
    }
    .right_foot {
        position: absolute;
        top: 623px;
        right: 178px;
    }
    .left_foot {
        position: absolute;
        top: 622px;
        right: 113px;
    }
    .right_leg_f {
        position: absolute;
        top: 406px;
        right: 173px;
    }
    .left_leg_f {
        position: absolute;
        top: 406px;
        right: 107px;
    }
    .right_arm_f {
        position: absolute;
        top: 245px;
        right: 220px;
    }
    .left_arm_f {
        position: absolute;
        top: 245px;
        right: 55px;
    }
    .stomach {
        position: absolute;
        top: 290px;
        right: 119px;
    }
    .right_hand_f {
        position: absolute;
        top: 375px;
        right: 263px;
    }
    .left_hand_f {
        position: absolute;
        top: 375px;
        right: 40px;
    }
    .neck_f {
        position: absolute;
        top: 150px;
        right: 149px;
    }
    .right_under_arm {
        position: absolute;
        top: 205px;
        right: 211px;
    }
    .left_under_arm {
        position: absolute;
        top: 204px;
        right: 99px;
    }


    .right_leg_b {
        position: absolute;
        top: 406px;
        right: 107px;
    }
    .left_leg_b {
        position: absolute;
        top: 405px;
        right: 173px;
    }
    .back {
        position: absolute;
        top: 187px;
        right: 125px;
    }
    .neck_b {
        position: absolute;
        top: 133px;
        right: 148px;
    }
    .glutes_buttock {
        position: absolute;
        top: 332px;
        right: 119px;
    }
    .right_arm_b {
        position: absolute;
        top: 245px;
        right: 55px;
    }
    .left_arm_b {
        position: absolute;
        top: 245px;
        right: 220px;
    }
    .right_hand_b {
        position: absolute;
        top: 374px;
        right: 39px;
    }
    .left_hand_b {
        position: absolute;
        top: 374px;
        right: 262px;
    }
</style>
